import { createBrowserClient } from '@supabase/ssr';
import { type Database } from '@/types/database.types';

export const createClient = () =>
  createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!,
    {
      cookieEncoding: 'raw',
      cookieOptions: {
        name: `tud-${process.env.NEXT_PUBLIC_SB_PROJECT_ID}-auth-token`,
        domain: process.env.NEXT_PUBLIC_SITE_NAME
      }
    }
  );
